<template>
	<div id="reporteador" class="container" >
		<H2>Reportes Disponibles</H2>
		<br>
<div id="pru1">
  <button-counter></button-counter>
</div>
<div>Seleccione el Reporte 
	<select id="selReportes" v-on:click = "reporteSeleccionado"></select> 
</div>
	<div style="display:none">

		<div id= 'configReporte' style="border: 2px solid aquamarine" align="left">
			<div align="center">
				<br>
				<br>
				
			</div>
			<br>

			<p>Archivo: {{cualArchivo2}}
				<select class = "select is-primary" id="elArchivo" v-on:change= 'getRegistros(); limpia(); iniciaDrop()' ></select>
			</p>
			<br>
			<table class="table ">
				<tr>
					<td>
						Campos a incluir
					</td>
					<td> 
						<select class = "select is-primary" id="loscampos" v-model="seleccion"   v-on:change= 'ponCampo(seleccion);generaCampo();generaCampoFechas();generaCampoNumeros();generaCampoTotales()'> 						
						</select>
						<span>
							{{seleccion}}
						</span>
					</td>
				</tr>
				<tr>
					<td>
						Campos a ordenar 
					</td>
					<td> 
						<select class = "select is-primary" id="losorden"  v-model="seleccion2" v-on:change='ponCampoOrden(seleccion2);generaCampoOrden();'>
							
						</select>
						<span>
							{{seleccion2}}
						</span>
					</td>
				</tr>
				<tr>
					<td>
						Campos a filtrar 
					</td>
					<td> 
						<select class = "select is-primary" id="losfiltros"  v-model="seleccion3" v-on:change='ponCampoFiltro(seleccion3);generaCampoFiltro();'></select>
						<span>
							{{seleccion3}}
						</span>
					</td>
				</tr>
			</table>
			<br>


			<div id='reporte' style="border: 2px solid aquamarine">
				<div id='elReporte' style="border: 2px solid aquamarine">
					Campos incluidos:
					<br>
				</div>
				<div id='elOrden' style="border: 2px solid aquamarine">
					Orden:
					<br>
				</div>
				<div id='elFiltro' style="border: 2px solid aquamarine">
					Filtros:
					<br>
				</div>

				<br>
				<div align="center">
					<button class="button is-primary" v-on:click='generaReporte()' >Generar reporte</button>
					&nbsp&nbsp&nbsp&nbsp
					<button class="button is-primary" v-on:click='guardarReporte()' >Guardar reporte</button>
					&nbsp&nbsp&nbsp&nbsp
					
				</div>
				<br>
			</div>
		</div>
		<br>
	</div>



		<div class="column is-one-quarter">
			Filtro
			<br><br>
			Atencion. Filtrar de la siguiente manera: {{letreroFiltros}}
			<br>
			<br>
			<select class = "select is-primary" id = "cualFiltroUsar" v-on:change='limpiar()'></select>
			<br>
			De<br>
			<input class="input is-primary" size="35" type="text" id="cualFiltroTexto" v-model= "filtroTexto">
			A<br>
			<input class="input is-primary" size="35" type="text" id="cualFiltroTexto2" v-model= "filtroTexto2">

			<button class="button is-primary" type= "button"  v-on:click = "filtrar()">
				FILTRAR
			</button>

			<button class="button is-primary" v-on:click='generaReporte(); quitarParametros()' >
				QUITAR FILTROS
			</button>
			<br><br>
			<button class="button is-primary" v-on:click="imprimir('reporteAver')">Imprimir reporte</button>

		</div>

		<div id="reporteAver" align="left">	
			<br>
			<h1><strong>{{nombreDelReporte}}</strong></h1>
			<br>
			<p>Contenido:{{banerFiltros}}</p>
			<br>

			<ul id='todos-lista' v-if="this.registrosTodos !=null" >
	  			<table align="left" class="table is-striped is-hoverable">
				    <thead>
						<tr>
							<th>{{titulo('0')}}
		 					</th>
							<th>{{titulo('1')}}
		 					</th>	
							<th>{{titulo('2')}}
		 					</th>
							<th>{{titulo('3')}}
		 					</th>
							<th>{{titulo('4')}}
		 					</th>	
							<th>{{titulo('5')}}
		 					</th>
							<th>{{titulo('6')}}
		 					</th>
							<th>{{titulo('7')}}
		 					</th>	
							<th>{{titulo('8')}}
		 					</th>
							<th>{{titulo('9')}}
		 					</th>
							<th>{{titulo('10')}}
		 					</th>	
							<th>{{titulo('11')}}
		 					</th>
							<th>{{titulo('12')}}
		 					</th>
							<th>{{titulo('13')}}
		 					</th>	
							<th>{{titulo('14')}}
		 					</th>
							<th>{{titulo('15')}}
		 					</th>

						</tr>
					</thead>

					<tbody  id='registros'>
						<tr v-for="contrat in this.registrosTodos" v-on:click="seleccion(contrat.id)">

							<td>{{colum('0',contrat)}}</td>
							<td>{{colum('1',contrat)}}</td>
							<td>{{colum('2',contrat)}}</td>
							<td>{{colum('3',contrat)}}</td>
							<td>{{colum('4',contrat)}}</td>
							<td>{{colum('5',contrat)}}</td>
							<td>{{colum('6',contrat)}}</td>
							<td>{{colum('7',contrat)}}</td>
							<td>{{colum('8',contrat)}}</td>
							<td>{{colum('9',contrat)}}</td>
							<td>{{colum('10',contrat)}}</td>
							<td>{{colum('11',contrat)}}</td>
							<td>{{colum('12',contrat)}}</td>
							<td>{{colum('13',contrat)}}</td>
							<td>{{colum('14',contrat)}}</td>
							<td>{{colum('15',contrat)}}</td>

						</tr>
					</tbody>

					<tfoot>
						<tr>
							<td>{{total("0")}}</td>
							<td>{{total("1")}}</td>
							<td>{{total("2")}}</td>
							<td>{{total("3")}}</td>
							<td>{{total("4")}}</td>
							<td>{{total("5")}}</td>
							<td>{{total("6")}}</td>
							<td>{{total("7")}}</td>
							<td>{{total("8")}}</td>
							<td>{{total("9")}}</td>
							<td>{{total("10")}}</td>
							<td>{{total("11")}}</td>
							<td>{{total("12")}}</td>
							<td>{{total("13")}}</td>
							<td>{{total("14")}}</td>
							<td>{{total("15")}}</td>
						</tr> 	
					</tfoot>
				</table>
			</ul>
			<span v-else>Cargando ...</span>
		</div>

	</div>
</template>

<script>

// lee los reportes guardados y los despliega

import axios from 'axios';

export default { 
  name: 'LeerRepHecho',
  mounted(){
	this.leerReporte();  	
  	this.getRegistros();
  	this.llenaNombreArchivos();
  },
  props: ['vector', 'elusuario'],  
  data () {
    return {
      registrosTodos: [],
      probando1: 'GMO',
      aparece: true,
      registrosTodos2: null,
  	  contando: true,
  	  delRenglon: 0,
  	  alRenglon: 0,
  	  columna:'',
  	  direccion:'',
  	  tipo:'',
  	  orden:[], // contiene los nombres de las columnas que se ordenaran
	  camposIncluye:[],
	  titulosDeColumnas:[],
	  camposFechados:[],
	  camposNumericos:[],
	  camposTotales:[], // contiene los nombres de las columnas a totalizar
	  columnasDeTotales:[],
	  camposFiltrar:[],
	  totales:[],
  	  llav: 'inquilino',
  	  seleccion: '',
  	  seleccion2: '',
  	  seleccion3: '',
  	  col1:'',
  	  col2:'',
  	  generando: false,
  	  elemento:'',
  	  anterior:'',
  	  esSubtotal: true,
  	  cualArchivo2:'',
  	  filtroTexto: '',
  	  filtroTexto2: '',
  	  filtroActual: '',
  	  banerFiltros: '',
  	  leerDirReporte: false,
  	  nombreDelReporte: "",
  	  letreroFiltros: ""
  	}
  },

  methods:{
  	getRegistros(){

 		// Valida usuario si tiene autorizacion para esta seccion o usa el paswword maestro  
     	var archiSel = document.getElementById('elArchivo').value;
  		if(!this.vector.includes('MASTERGGUV')){
	  		if(this.vector.includes('Reportes')){
	  			if(!this.vector.includes('Reportes de ' + archiSel)){
		  			alert('Seccion no autorizada');
		  			return;	
	  			}	  			
	  		}else return;
	  	}

  		this.registrosTodos = [];
     	var renglon = [];
     	var cualArchivo = document.getElementById('elArchivo').value;

     	if (cualArchivo){

     		var cadena = 'https://www.directodo.com/Rentus/accesosdb/lee'+ cualArchivo + '.php';

	  		axios.get(cadena)
	  		     .then((respuesta) => {

	  		     	this.registrosTodos = respuesta.data;// recibe un objeto

	  		     	// llena el selector de los campos
	  		     	this.llenaCampos();

					// llama a los totales antes de llamar a ordenar porque puede ser que no 
					// haya registros a ordenar y suspenda la continuacion de la ejecucion
					// tambien llama a mi SORTUSTotals para totalizar las columnas seleccionadas a totalizar
					if(!this.camposTotales == "" && !this.registrosTodos == "") {
						this.totales = this.$sortusTotals(this.registrosTodos,this.camposTotales);				
					}

	  		     	// ordena el resultado con MI SORTUS pasando el objeto a ordenar y 
	  		     	// el array que contiene los nombres de los campos a ordenar
	  		     	if(!this.registrosTodos == "" && !this.orden == ""){
						this.registrosTodos = this.$sortus(this.registrosTodos,this.orden);
	  		     	}

	  			});
     	}
 
  	},

  	limpia: function(){
     	this.cualArchivo2 = document.getElementById('elArchivo').value;
  		document.getElementById('elArchivo').hidden = true;

  	},

  	iniciaDrop(){
  		// al cambiar el archivo seleccionado inicializa los selects
		var selectBox = document.getElementById("loscampos");
		selectBox.innerHTML = ""; 
		this.seleccion = "";
		this.seleccion2 = "";
		this.seleccion3 = "";
		var selectBox = document.getElementById("losorden");
		selectBox.innerHTML = ""; 
		var selectBox = document.getElementById("losfiltros");
		selectBox.innerHTML = ""; 
		
		document.getElementById("elReporte").innerHTML = "Campos incluidos:"
		document.getElementById("elOrden").innerHTML = "Orden:"
		document.getElementById("elFiltro").innerHTML = "Filtros:"
  	},		

  	filtrar: function(){
  		this.registrosTodos = this.filtrando;
  		// tambien llama a recalcular totales
  		this.totales = this.$sortusTotals(this.registrosTodos,this.camposTotales);

  		this.cualFiltroTexto2 = "";
  		this.cualFiltroTexto = "";
  	},

  	ponCampo: function(campo){// agrega campo al reporte. Lo corre despues 
  							  // de ponCampo
  		// AGREGA EL BOTON CAMPO						
  		document.getElementById("elReporte").innerHTML += '&nbsp&nbsp&nbsp<button class="campos" id="'+campo+'">'+campo+' x </button>';	

  		// AGREGA EL BOTON FECHA
  		var nombre = campo +'F';
  		document.getElementById("elReporte").innerHTML += '<button class="fecha" style="background-color:white;" id="'+nombre+'"> F </button>';	

  		// AGREGA EL BOTON NUMERICO
  		var nombre = campo +'N';
  		document.getElementById("elReporte").innerHTML += '<button class="numero" style="background-color:white;" id="'+nombre+'"> # </button>';

  		// AGREGA EL BOTON TOTAL
  		var nombre = campo +'T';
  		document.getElementById("elReporte").innerHTML += '<button class="total" style="background-color:white;" id="'+nombre+'"> T </button>';

  	},

  	ponCampoOrden: function(campo){// agrega campo a ordenar en el reporte
  		var nombre = campo +'.';
  		document.getElementById("elOrden").innerHTML += '&nbsp&nbsp&nbsp<button class="ordenar" id="'+nombre+'">'+nombre+' x </button>';	
  	},

  	ponCampoFiltro: function(campo){// agrega campo a filtrar en el reporte
  		var nombre = campo +'*';
  		document.getElementById("elFiltro").innerHTML += '&nbsp&nbsp&nbsp<button class="filtrar" id="'+nombre+'">'+nombre+' x </button>';	
  	},

  	generaCampo: function(){ // genera el reporte la parte a incluir
	  	var item = '';
	    var elms = document.getElementById('elReporte').getElementsByClassName("campos");

	    // les agrega funciones a los botones.
	    for (var i = 0; i < elms.length; i++) {
	    	item = elms[i].id;
			document.getElementById(item).onclick = function() {
				// al click borra este botón y el de fecha y el de Total
				this.remove();
				document.getElementById(this.id +'F').remove();
				document.getElementById(this.id +'N').remove();
				document.getElementById(this.id +'T').remove();
			}; 
	    }
	    this.llenaCamposOrdenar();// llena el select aordenar
	    this.llenaCamposFiltrar();// llena el select afiltrar
	},

	generaCampoOrden: function(){ // agrega la parte del reporte los campos a ordenar
	  	var item = '';
	    var elm = {};
	    var elms = document.getElementById('elOrden').getElementsByClassName("ordenar");

	    for (var i = 0; i < elms.length; i++) {
	    	item = elms[i].id;
			document.getElementById(item).onclick = function() {
				this.remove();// borra el componente
			}; 
	    }
	    
	},

	generaCampoFiltro: function(){ // agrega la parte del reporte los campos a filtrar
	  	var item = '';
	    var elm = {};
	    var elms = document.getElementById('elFiltro').getElementsByClassName("filtrar");

	    for (var i = 0; i < elms.length; i++) {
	    	item = elms[i].id;
			document.getElementById(item).onclick = function() {
				this.remove();// borra el componente
			}; 
	    }
	    
	},

	generaCampoFechas: function(){
	  	var item = '';
		var elms = document.getElementById('elReporte').getElementsByClassName("fecha");
	    for (var i = 0; i < elms.length; i++) {
	    	item = elms[i].id;
			document.getElementById(item).onclick = function() {
				if (this.style.backgroundColor == 'fuchsia'){
					this.style.backgroundColor = 'white';
				}else {
					this.style.backgroundColor = 'fuchsia';
				}	
			}; 
	    }
	},

	generaCampoNumeros: function(){
	  	var item = '';
		var elms = document.getElementById('elReporte').getElementsByClassName("numero");
	    for (var i = 0; i < elms.length; i++) {
	    	item = elms[i].id;
			document.getElementById(item).onclick = function() {
				if (this.style.backgroundColor == 'yellow'){
					this.style.backgroundColor = 'white';
				}else {
					this.style.backgroundColor = 'yellow';
				}	
			}; 
	    }
	},

	generaCampoTotales: function(){
	  	var item = '';
		var elms = document.getElementById('elReporte').getElementsByClassName("total");
	    for (var i = 0; i < elms.length; i++) {
	    	item = elms[i].id;
			document.getElementById(item).onclick = function() {

				switch(this.style.backgroundColor) {
  					case "white":
    					this.style.backgroundColor = 'lime';
						this.innerHTML = "Contar";
    					break;
  					case "lime":
    					this.style.backgroundColor = 'aqua';
						this.innerHTML = "Sumar";
    					break;
  					case "aqua":
    					this.style.backgroundColor = 'white';
						this.innerHTML = "T";
    					break;
				}					
			}; 
	    }
	},

    generaReporte: function(){

    	// obtiene el nombre del archivo en cuestion para sugerirlo como nombre del reporte
     	if(this.nombreDelReporte == ""){
         	var cualArchivo = document.getElementById('elArchivo').value; 		
     		this.nombreDelReporte = cualArchivo;
     	}

		this.nombreDelReporte = prompt("Encabezado del reporte ?", cualArchivo);

    	this.generando = true; // resetea reporte y bandera que es nuevo reporte
    	this.banerFiltros = ''; // limpia baner de los filtros.

	    var item,itemColor = '';
	    var elm = {};
	    this.orden = [];
	    this.camposIncluye = [];
	    this.camposFechados = [];
	    this.titulosDeColumnas = [];
	    this.camposNumericos = [];
	    this.camposTotales = [];
	    this.camposFiltrar = [];
	    this.registrosTodos = [];
	    
	    // crea el array de los campos a incluir
	    elms = document.getElementById('elReporte').getElementsByClassName("campos");
	    for (var i = 0; i < elms.length; i++) {
	    	item = elms[i].id;
			//en 'camposIncluye' deja los campos a incluir en el reporte
			this.camposIncluye.push(item);
	    };

	    // crea el array de los campos a ordenar. Les quita el punto decimal
	    // que le agregamos al nombre al final para diferenciarlos de los demas
	    var elms = document.getElementById('elOrden').getElementsByClassName("ordenar");
	    for (var i = 0; i < elms.length; i++) {
	    	item = elms[i].id;
			this.orden.push(item.replace('.',''));// en el campo 'orden' deja los campos a ordenar
	    };


	    // crea el array de los campos a formatear como fecha. los de fondo rojo
	    elms = document.getElementById('elReporte').getElementsByClassName("fecha");
	    for (var i = 0; i < elms.length; i++) {
	    	item = elms[i].id;
	    	itemColor = elms[i].style.backgroundColor;
			//en 'camposFechados' deja los campos a formatear como fecha
			// y le quita la F
			item = item.replace('F','');
			if (itemColor == 'fuchsia'){
				this.camposFechados.push(item);
				// MODIFICA EL ARRAY DE ORDEN PARA QUE SE VAYA AL SORTUS CON LOS
				// PARÁMETROS ADECUADOS
				for (var elemento in this.orden){
					if (this.orden[elemento] == item){
						this.orden[elemento] = item + '+D';
					}
				}
			}
	    };

	    // crea el array de los campos a formatear como NUMERO. los de fondo AMARILLO
	    elms = document.getElementById('elReporte').getElementsByClassName("numero");

	    for (var i = 0; i < elms.length; i++) {
	    	item = elms[i].id;
	    	itemColor = elms[i].style.backgroundColor;

			//en 'camposFechados' deja los campos a formatear como fecha
			// y le quita la N
			item = item.replace('N','');
			if (itemColor == 'yellow'){
				this.camposNumericos.push(item);

				// MODIFICA EL ARRAY DE ORDEN PARA QUE SE VAYA AL SORTUS CON LOS
				// PARÁMETROS ADECUADOS
				for (var elemento in this.orden){
					if (this.orden[elemento] == item){
						this.orden[elemento] = item + '+N';
					}
				}
			}

	    };

	    // crea el array de los campos a totalizar. Los de fondo lime
	    elms = document.getElementById('elReporte').getElementsByClassName("total");
	    for (var i = 0; i < elms.length; i++) {
	    	item = elms[i].id;
	    	itemColor = elms[i].style.backgroundColor;

			//en 'camposTotales' deja los nombres de las columnas a totalizar 
			// y le quita la T
			item = item.replace('T','');

			if (itemColor == 'lime' || itemColor == "aqua"){
				if(itemColor == "aqua") item = item + "*";
				this.camposTotales.push(item);
			}
	    };

	    // llena el array de los campos a filtrar
	    elms = document.getElementById('elFiltro').getElementsByClassName("filtrar");
	    for (var i = 0; i < elms.length; i++) {
	    	item = elms[i].id;
			//en 'camposIncluye' deja los campos a incluir en el reporte
			this.camposFiltrar.push(item);
	    };

	    // llena el select de filtros
		var selector = document.getElementById('cualFiltroUsar');
		selector.length = 0; // lo limpia primero
	    for ( var i in this.camposFiltrar){
	    	var campo = this.camposFiltrar[i].replace('*','');
		    selector.add(new Option(campo));
	    }

	    this.getRegistros();

    },
	

  	imprimir: function(divName) {
	     var printContents = document.getElementById(divName).innerHTML;
	     var originalContents = document.body.innerHTML;
	     document.body.innerHTML = printContents;
	     window.print();
	},

	llenaNombreArchivos: function(){ // llena los select
		// son los nombres de los archivos del backend
		var loscampos2= ['Archivo','Contratos','Inquilinos','Movimientos','Propiedades'];
		var selector1 = document.getElementById('elArchivo');

		var c1;
		for(c1 in loscampos2) {
		    selector1.add(new Option(loscampos2[c1]));
		};

	},

	llenaCampos: function(){
		var loscampos1 =[];
	    // toma los titulos de los campos
		for (var key in this.registrosTodos[0]){
		// lee campo por campo del registro primero y llena un array con los nombres de las columnas
			loscampos1.push(key);
		} 

		var selector2 = document.getElementById('loscampos');
		selector2.length=0; // lo limpia primero

		var c;
		for(c in loscampos1) { // lo llena con los nombres de los campos
		    selector2.add(new Option(loscampos1[c]));
		};

	},

	llenaCamposOrdenar: function(){ // llena el select losorden

		var selectBox = document.getElementById("losorden");
		selectBox.innerHTML = ""; // lo limpia

		// extrae los elementos del select campos
		var elms = document.getElementById('elReporte').getElementsByClassName("campos");
		var item;
		var loscampos3;
		this.titulosDeColumnas = [];

	    for (var i = 0; i < elms.length; i++) {
	    	item = elms[i].id;
			this.titulosDeColumnas.push(item.replace('.',''));// en el campo 'consec' deja los campos a ordenar
	    };

		loscampos3= this.camposIncluye;
		var	selector3 = document.getElementById('losorden');
		selector3.length=0; // lo limpia

		for(var c in this.titulosDeColumnas) {
		    selector3.add(new Option(this.titulosDeColumnas[c]));
		};

	},

	llenaCamposFiltrar: function(){ // llena el select losorden
		// primero lo limpia
		var selectBox = document.getElementById("losfiltros");
		selectBox.innerHTML = ""; 
		// extrae los elementos del select LOSCAMPOS
		var elms = document.getElementById('elReporte').getElementsByClassName("campos");
		var item;
		var loscampos3;
		this.titulosDeColumnas = [];
	    for (var i = 0; i < elms.length; i++) {
	    	item = elms[i].id;
			this.titulosDeColumnas.push(item.replace('.,',''));// en el campo 'consec' deja los campos a ordenar
	    };
		loscampos3= this.camposIncluye;
		var	selector3 = document.getElementById('losfiltros');
		selector3.length=0; // lo limpia

		if(this.titulosDeColumnas.length > 0){ //vailida si existe
			for(var c in this.titulosDeColumnas) {
			    selector3.add(new Option(this.titulosDeColumnas[c]));
			};
		}
	},

	colum: function(columna, registro){ // CREA LAS COLUMNAS EN EL REPORTE
		// recibe todo el registro 
		// checa si es la primera vez (generando = true) nuevo reporte y cambia los 
		// campos como se desplegarán. Solo lo hace una vez cada nuevo registro

		if (this.generando == true){ // si es nuevo reporte toma encabezados
			this.titulosDeColumnas = [];
			for (var cada in this.camposIncluye){//lee campos que se incluirán
				for (var titulo in registro){// lee campo por campo del registro
					if (this.camposIncluye[cada] == titulo){
						this.titulosDeColumnas.push(titulo);//guarda la posición del
						break;                         //campo que si se incluirá
					}
				}
			}

			this.generando = false; // apaga la bandera de que es nuevo
		}

		// despliega los campos en el orden que se pidió el reporte.
		// checa si este campo debe llevar formato de fecha o numero y lo formatea
		var elemento = this.titulosDeColumnas[parseInt(columna)];

		var esfecha = this.camposFechados.includes(elemento);
		if (esfecha){
			// es con formato de fecha
			return this.formateaFecha2(registro[elemento]);

		}else{
			var esnumero = this.camposNumericos.includes(elemento);
			if (esnumero){
				// es con formato de numero
				return this.FormateaNumero2(registro[elemento]);
			}else{
				// no es ni fecha ni numero
				return registro[this.titulosDeColumnas[parseInt(columna)]];
			}
		}

	},


	titulo: function(tit){
		//con el numero de columna regresa el titulo de la columna
		return this.titulosDeColumnas[tit];
	},


	formateaFecha2: function (fecha) {

		var d = new Date(fecha); 
		if (Date.parse(d)){
			// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
			d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
			//d.setHours(0);
			var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
			d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
			return d

		}else{
			return "sin fecha";
		}
	},

	guardarReporte (){
		var nombreReporte = prompt("Nombre del reporte ?", "");

		if(nombreReporte == "") return;

     	var archiSel = document.getElementById('elArchivo').value;

     	// guarda los array en formato json para despues poderlos desserializar de json a array
		var cadena = 'https://www.directodo.com/Rentus/accesosdb/guardaReporte.php?cliente=RGGUV1'+
						'&nombreReporte='+nombreReporte+
						'&archivo='+archiSel+
						'&encabezado='+this.nombreDelReporte+
						'&descripcion='+this.banerFiltros+
						'&camposIncluye=' + JSON.stringify(this.camposIncluye)+
						'&orden=' + JSON.stringify(this.orden)+
						'&camposTotales=' + JSON.stringify(this.camposTotales)+
						'&camposFiltrar=' + JSON.stringify(this.camposFiltrar)+
						'&filtrosAplicados='+
						'&autor='+this.elusuario+
						'&status=' + "A";

  		axios.post(cadena)
  		     .then((respuesta) => {
  		     	this.registrosTodos = respuesta.data;// recibe un objeto
  			 })

	},

	leerReporte (){

		// llena el select de los reportes disponibles
		var selectorRep = document.getElementById('selReportes');

		var cadena = 'https://www.directodo.com/Rentus/accesosdb/leeReporte.php';

  		axios.post(cadena)
  		     .then((respuesta) => {
  		     	var todosLosReportes = respuesta.data;// recibe un objeto

  		     	// llena el select de reportes		
  		     	selectorRep.length = 0;// lo limpia primero
  		     	for(var rep in todosLosReportes){ // lee cada registro
  		     		var campo = "";
  		     		for(campo in todosLosReportes[rep]){// lee cada campo del registro
  		     			if(campo = "nombreReporte") break;
  		     		}  
  		     		// agrega el elemento del campo
					var opcion = document.createElement("option");

					opcion.value = todosLosReportes[rep]["consec"];
					opcion.text = todosLosReportes[rep][campo] + "    " + todosLosReportes[rep]["autor"];
					
					selectorRep.add(opcion, null);
  		     	} 
  		})

  		this.leerDirReporte = true;
	},

	reporteSeleccionado(){
		var selectorRep1 = document.getElementById('selReportes');

		var cadena = 'https://www.directodo.com/Rentus/accesosdb/leeUnReporte.php?repnum=' + selectorRep1.value;

     	var cualArchivo = document.getElementById('elArchivo');

		axios.get(cadena)
		    .then((respue) => {
		   		var  losReportes = respue.data;

		   		// llena los selects del reporte.
		   		// los array vienen en formato JSON por eso los pasa a array
		   		cualArchivo.value = losReportes[0]["archivo"];

		   		this.camposIncluye = JSON.parse(losReportes[0]["camposIncluye"]);
		   		this.orden = JSON.parse(losReportes[0]["orden"]);
		   		this.camposFiltrar = JSON.parse(losReportes[0]["camposFiltrar"]);
		   		this.camposTotales = JSON.parse(losReportes[0]["camposTotales"]);
		   		this.nombreDelReporte = losReportes[0]["encabezado"];
		   		this.letreroFiltros = losReportes[0]["descripcion"];


		   		this.llenaCamposOrdenar();		   		
		   		this.llenaCamposFiltrar();
		   		this.generando = true;

		   		this.getRegistros();
		   		
			    // llena el select de filtros
				var selector = document.getElementById('cualFiltroUsar');
				selector.length = 0; // lo limpia primero
			    for ( var i in this.camposFiltrar){
			    	var campo = this.camposFiltrar[i].replace('*','');
				    selector.add(new Option(campo));
			    }	

		   		//this.limpia();
		   		//this.iniciaDrop();		   		

			 });

	},
	quitarParametros(){		
		this.filtroTexto = "";
		this.filtroTexto2 = "";
		// tambien llama a recalcular totales
  		this.totales = this.$sortusTotals(this.registrosTodos,this.camposTotales);
	},

    FormateaNumero2 (valor1) {
        return (Number(valor1)).toLocaleString('en-US', {minimumFractionDigits: 2, useGrouping:true});
    },

  	total: function(columna){
		var titulo = this.titulosDeColumnas[columna];

		// les quita a los campos totales el * en el caso de que lo tengan
		var camposT = [];
		for(var i in this.camposTotales){
			camposT.push(this.camposTotales[i].replace("*",""));
		}

		var lugar = camposT.indexOf(titulo);

		var contenido = this.totales[lugar];

		if(isNaN(contenido)) return contenido;
		else return this.FormateaNumero2(contenido);
  	},

  	limpiar: function(){
  		var filtro1 = document.getElementById('cualFiltroTexto');
  		var filtro2 = document.getElementById('cualFiltroTexto2');
  		filtro1.value = "";
  		filtro2.value = "";
  	}


  	// terminan las funciones
  },


    computed:{
	 	filtrando: function(){
			var campoSeleccionado = document.getElementById('cualFiltroUsar').selectedOptions[0].value;
			// si está vacio entonces iguala los campos
			if(this.filtroTexto2 == '') this.filtroTexto2 = this.filtroTexto; 
			// pone letreros informativos de los filtros que se usarán.
	 		this.banerFiltros = this.banerFiltros + ' (EN '+campoSeleccionado+' DE '+this.filtroTexto+' A '+this.filtroTexto2+')';

	 		// aplica los filtros en el array registrosTodos y devuelve filtrado en esta computada solo los que estan en el rango señalado. el 1 lo agregamos para que funcione correcto el filtro
			return this.registrosTodos.filter(
				(item) => 
				item[campoSeleccionado] >= this.filtroTexto && 
				item[campoSeleccionado] <= this.filtroTexto2 + '1');	
		}
	}

}

</script>

<style lang="scss">
 
</style>


// WEBPACK FOOTER //
// src/ReportesHechos.vue